<div class="container" *ngIf="!isProgress && status">
    <div class="row justify-content-center bg-white py-3">
        <div class="col-md-12 text-center">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" height="100px" width="100px" viewBox="0 0 24 24" width="100px"
                    fill="#28a745">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
            </div>
            <p>You have completed the Q2E GateCube configuration and bot installation. You can now receive Q2E platform notifications and work on your task assignments from within your Slack channel.</p>
        </div>
    </div>
</div>

<div class="container" *ngIf="!isProgress && !status">
    <div class="row justify-content-center bg-white py-3">
        <div class="col-md-12 text-center">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" height="100px" width="100px" viewBox="0 0 24 24"  fill="#ff3333">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
            </div>
            <p>Invalid Authentication URL OR server is Down.</p>
        </div>
    </div>
</div>
